<template>
  <div
    v-if="blok"
    v-editable="blok"
    class="flex size-full flex-col items-start justify-start"
    :class="[
      {
        'justify-center': blok.verticalAlignement === 'centered',
        'justify-end': blok.verticalAlignement === 'bottom',
      },
      {
        'items-center': blok.horizontalAlignement === 'centered',
        'items-end': blok.horizontalAlignement === 'right',
      },
    ]"
  >
    <component
      :is="
        ['Image'].includes(content.component) ? 'CmsImage' : content.component
      "
      v-for="content in blok.content"
      :key="content._uid"
      :blok="content"
      :sibling-count="siblingCount"
      :sibling-index="siblingIndex"
      :optimise-desktop="
        ['Image', 'InteractableImage'].includes(content.component) &&
        (columnCount || 1) > 1
      "
      class="flex max-w-full"
      :class="{
        'w-full': ['Image', 'InteractableImage'].includes(content.component),
      }"
    />
  </div>
</template>

<script lang="ts">
import { computed, getCurrentInstance, defineComponent } from 'vue'
import type { PropType } from 'vue'
import type { SbColumn, SbGrid } from '~/cms/storyblok/types/storyblok.d.ts'
import {
  COLUMN_SIBLING_INDEX_KEY,
  GRID_SIBLING_COUNT_KEY,
} from '../../constants/injectionKeys'
import cmsPaddingMixin from '../../storyblok/mixins/cmsPaddingMixin'

export default defineComponent({
  mixins: [cmsPaddingMixin],
  props: {
    blok: {
      type: Object as PropType<SbColumn>,
      default: () => {},
    },
    siblingIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    provide(COLUMN_SIBLING_INDEX_KEY, props.siblingIndex)

    const siblingCount = inject(GRID_SIBLING_COUNT_KEY, undefined)

    const instance = getCurrentInstance()
    const cmsParentBlok = computed(
      () =>
        ((instance as any)?.parent?.props?.blok as SbGrid | undefined) || null,
    )
    const columnCount = computed(() => {
      if (cmsParentBlok.value?.component === 'Grid') {
        return cmsParentBlok.value.columns?.length
      }
      return siblingCount ?? 1
    })
    return {
      columnCount,
      siblingCount,
    }
  },
})
</script>
